module.exports = __webpack_public_path__ + "img/link-zg.3e95a2c3.jpg";